<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <core-card [actions]="[]">
      <div class="card-title w-100">
        <div [ngClass.xl]="'float-left'" [ngClass.sm]="'mb-075'" [ngClass.md]="'mb-075'">
          <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="filterList()" />
        </div>
        <div class="float-right">
          <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
            <label class="d-flex align-items-center mb-0" *ngIf="config.selectLimitItems"
              >{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
          <a class="btn btn-outline-primary text-primary" (click)="modalOpen(modalAdd, null)" *ngIf="_authenticationService.hasCapability('create_job_positions_category')">{{ "ADD" | translate }}</a>
        </div>
        <div class="clearboth"></div>
      </div>

      <!-- desktop-->
      <div class="card-body px-0 pb-0" *ngIf="_utilService.isDesktop">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="config.headerHeight"
          [scrollbarH]="config.scrollbarH"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="config.rowHeight"
          [limit]="tableLimit"
          [footerHeight]="config.footerHeight"
          [rows]="filteredJobCategoriesList"
        >
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" width="700" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'DESCRIPTION' | translate" prop="description" width="200" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.description }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div>
                <button class="bg-transparent border-0 text-secondary pr-1" (click)="modalOpen(modalEdit, row)" *ngIf="_authenticationService.hasCapability('edit_job_positions_category')">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="delete(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_job_positions_category')">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>

      <!--mobile - tablet-->
      <div class="card-body px-0 pb-0" *ngIf="_utilService.isMobile || _utilService.isTablet">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="config.headerHeight"
          [scrollbarH]="config.scrollbarH"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="150"
          [limit]="tableLimit"
          [footerHeight]="config.footerHeight"
          [rows]="filteredJobCategoriesList"
        >
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" width="700" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile align-items-center">
                <div class="col-12">
                  <span class="font-weight-bold">{{ "NAME" | translate }}: </span>
                  <span>{{ row.name }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "DESCRIPTION" | translate }}: </span>
                  <span>{{ row.description }}</span>
                </div>
                <div class="col-12 mt-075 text-right">
                  <div>
                    <button class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_job_positions_category')" (click)="modalOpen(modalEdit, row)">
                      <i [data-feather]="'edit-2'" size="19"></i>
                    </button>
                    <button (click)="delete(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_job_positions_category')">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>

<!-- Modal Edit -->
<ng-template #modalEdit let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "EDIT" | translate }} {{ "JOB_CATEGORY" | translate }}</h3>
    <div class="row">
      <div class="form-group col-12">
        <label [for]="'name'">{{ "JOB_CATEGORY" | translate }}<sup class="text-danger">*</sup></label>
        <input name="name" [(ngModel)]="jobCategory.name" type="text" [id]="'name'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!jobCategory.name || jobCategory.name.length < 1 || jobCategory.name.trim() === '')">{{ "ERRORS.INSERT_JOB_POSITIONS_CATEGORY" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label for="descriptionEdit">{{ "DESCRIPTION" | translate }}</label>
        <textarea name="description" id="descriptionEdit" [(ngModel)]="jobCategory.description" class="form-control"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "ALERT.BTN_CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="edit()">
      {{ "EDIT" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Modal Edit -->

<!-- Modal Add -->
<ng-template #modalAdd let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "ADD" | translate }} {{ "JOB_CATEGORY" | translate }}</h3>
    <div class="row">
      <div class="form-group col-12">
        <label [for]="'name'">{{ "JOB_CATEGORY" | translate }}<sup class="text-danger">*</sup></label>
        <input name="name" [(ngModel)]="jobCategory.name" type="text" [id]="'name'" class="form-control" />
        <div class="font-error" *ngIf="showModalError && (!jobCategory.name || jobCategory.name.length < 1 || jobCategory.name.trim() === '')">{{ "ERRORS.INSERT_JOB_POSITIONS_CATEGORY" | translate }}</div>
      </div>
      <div class="form-group col-12">
        <label for="description">{{ "DESCRIPTION" | translate }}</label>
        <textarea name="description" id="description" [(ngModel)]="jobCategory.description" class="form-control"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "ALERT.BTN_CANCEL" | translate }}
    </button>
    <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="add()">{{ "SEND" | translate }}/{{ "ERRORS.INSERT" | translate }}</button>
  </div>
</ng-template>
<!-- / Modal Add -->
